export default __webpack_public_path__ + "imgs/Logo_SP.png";